
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../node_modules/core-js/modules/es.array.reduce.js';
import '../../../node_modules/core-js/modules/es.object.to-string.js';
import '../../../node_modules/core-js/modules/es.string.includes.js';

var _filterListByKeyword = function filterListByKeyword(list, keyword) {
  return list.reduce(function (arr, item) {
    var items = item.items,
      label = item.label,
      originalText = item.originalText;
    if (items && items.length > 0) {
      var filteredItems = _filterListByKeyword(items, keyword);
      if (filteredItems.length > 0) {
        arr.push(_objectSpread2(_objectSpread2({}, item), {}, {
          items: _toConsumableArray(filteredItems)
        }));
      }
      return arr;
    }
    if (typeof label === "string") {
      if (label.toLowerCase().includes(keyword.toLowerCase())) {
        arr.push(item);
      }
    } else if (originalText) {
      if (originalText.toLowerCase().includes(keyword.toLowerCase())) {
        arr.push(item);
      }
    }
    return arr;
  }, []);
};
var _getScrollableParent = function getScrollableParent(node) {
  var isElement = node instanceof HTMLElement;
  var overflowY = isElement && window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== "visible" && overflowY !== "hidden";
  if (!node) {
    return null;
  } else if (isScrollable && isElement && node.scrollHeight >= node.clientHeight) {
    return node;
  }
  return _getScrollableParent(node.parentNode) || null;
};
var getInlinePaddingStart = function getInlinePaddingStart(level, isSearchable) {
  var initialPadding = isSearchable ? 0.25 : 1;
  return initialPadding + level * 0.75;
};

export { _filterListByKeyword as filterListByKeyword, getInlinePaddingStart, _getScrollableParent as getScrollableParent };
//# sourceMappingURL=helpers.js.map
